import MFA from "../../components/MyAccount/MFA";
import Profile from "../../components/MyAccount/Profile";
import Security from "../../components/MyAccount/Security";

export const tabBarOptions = [
  { id: 1, title: "Profile", Component: Profile },
  { id: 2, title: "Security", Component: Security },
  { id: 3, title: "Multi Factor Authentication", Component: MFA },
];
